import { useState } from 'react';
import Button from 'components/ui/button';
import Input from 'components/ui/input';
import Form from 'components/ui/form';
import Loader from 'components/ui/loader';
import ModalTitle from '../components/ModalTitle';
import ModalContent from '../components/ModalContent';
import ModalFooter from '../components/ModalFooter';
import { createInternalDomain, updateInternalDomain } from '../../../api/internalDomain';
import { useTranslation } from '../../../hooks';

interface Props {
  callback: ({ data }: { data: any }) => void;
  content: {
    data: any;
  };
}

const EditInternalDomain: React.FC<Props> = ({ callback, content: { data } }) => {
  const [form, setForm] = useState(() => getInitialForm(data));
  const [isLoading, setLoading] = useState(false);
  const getTranslate = useTranslation();

  function getInitialForm(data: any) {
    if (!data) {
      return {
        domain: '',
        created_at: '',
        created_by: '',
        updated_at: '',
        updated_by: '',
      };
    }

    return data;
  }

  const changeForm = (key: string, value: string) => {
    setForm((prevForm) => ({ ...prevForm, [key]: value }));
  };

  const sendForm = async () => {
    setLoading(true);
    try {
      const { id } = data;
      let editedRow;
      if (id === undefined) {
        editedRow = await createInternalDomain(form);
        editedRow = { ...editedRow, isNew: true };
      } else {
        editedRow = await updateInternalDomain(form);
      }
      
      callback({ data: editedRow });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const { id } = data;

  return (
    <>
      <ModalTitle>{(id ? 'Edit' : 'New')}</ModalTitle>
      <ModalContent>
        <Form onSubmit={sendForm}>
          <Input
            autoFocus
            id='id-domain'
            label='Domain'
            value={form.domain}
            placeholder='Enter domain'
            onChange={(e) => changeForm('domain', e.target.value)}
          />
          <br />
          <Input
            id='id-created-at'
            label='Created At'
            value={form.created_at}
            disabled={true}
          />
          <br />
          <Input
            id='id-created-by'
            label='Created By'
            value={form.created_by}
            disabled={true}
          />
          <br />
          <Input
            id='id-updated-at'
            label='Updated at'
            value={form.updated_at}
            disabled={true}
          />
          <br />
          <Input
            id='id-updated-by'
            label='Updated by'
            value={form.updated_by}
            disabled={true}
          />
        </Form>
      </ModalContent>
      <ModalFooter>
        <Button text={getTranslate('internalDomain.modal.save')} status='primary' onClick={sendForm} />
      </ModalFooter>
      {isLoading && <Loader />}
    </>
  );
};

export default EditInternalDomain;
